const TYPOGRAPHY = 'text-l-base';

// eslint-disable-next-line import/prefer-default-export
export { TYPOGRAPHY };
